import { type FC } from 'react'
import { useTheme } from 'styled-components'

import { BodyText } from '@/ui/atoms/body-text'
import { Flex } from '@/ui/atoms/flex'
import { Star } from '@/ui/atoms/star-meter/styled'

type ListingPosterReviewProps = {
  rating?: number | null
}

export const ListingPosterReview: FC<ListingPosterReviewProps> = ({ rating }) => {
  const { colors, spacing } = useTheme()

  if (!rating) return null

  return (
    <Flex alignItems="center" gap={spacing.mini}>
      <Star $length={1} $size="small" aria-hidden color={colors.grey.light1} />
      <BodyText size="xSmall" color={colors.grey.light1}>
        {rating.toFixed(1)}
      </BodyText>
    </Flex>
  )
}
